<div class="xn-form">
  <div
    *ngFor="let field of getCanShowField()"
    class="xn-row-wrapper {{field.rowClass}}"
  >

    <div class="xn-form-line" [id]="'xn-field-' + field.name" *ngIf="field.type === 'line'"></div>

    <div class="" *ngIf="field.type !== 'line'">
      <div class="flex-1">
        <app-xn-form-control
          *ngIf="field.type !== 'row' && canShow(field)"
          #xnControl
          [(ngModel)]="values[field.name]"
          [name]="field.name"
          [label]="field.label"
          [type]="getFieldType(field)"
          [required]="$any(field.required)"
          [submitted]="submitted"
          [styleClass]="$any(styleClass)"
          [displayType]="displayType"
          [placeholder]="field.placeholder"
          [minDate]="field.minDate"
          [maxDate]="field.maxDate"
          [dateFormat]="field.dateFormat"
          [selectOptions]="field.selectOptions"
          [optionLabel]="field.optionLabel"
          [optionValue]="field.optionValue"
          [translateOptions]="field.translateOptions"
          (onStateChanged)="onFieldStateChanged($event)"
          [customValidateError]="field.customValidateError"
          [values]="values"
          (onFieldChanged)="field.onChanged ? field.onChanged($any($event)) : undefined"
          [autocomplete]="field.autocomplete"
          [passwordFeedback]="field.passwordFeedback"
          [passwordToggleMask]="field.passwordToggleMask"
          [readonly]="field.readonly"
          [fileHint]="$any(field.fileHint)"
          [fileButtonText]="field.fileButtonText"
          [fileAccept]="field.fileAccept"
          [disabled]="$any(field.disabled)"
          [fileHintHtml]="field.fileHintHtml"
          [fileHintHtmlTranslate]="field.fileHintHtmlTranslate"
          [fileMaxSizeInMb]="field.fileMaxSizeInMb"
          [hideLabel]="field.hideLabel"
          [validationType]="field.validationType"
          [maxLength]="field.maxLength"
          [minLength]="field.minLength"
          [calendarView]="field.calendarView"
          [hidePasswordHints]="field.hidePasswordHints"
        ></app-xn-form-control>
      </div>
    </div>

    <div *ngIf="field.type === 'row'" class="xn-form-row lg:flex">
      <ng-container *ngFor="let columnField of field.columns">
        <div class="flex-1" *ngIf="canShow(columnField)">
          <app-xn-form-control
            *ngIf="columnField.type !== 'empty'"
            #xnControl
            [(ngModel)]="values[columnField.name]"
            [name]="columnField.name"
            [label]="columnField.label"
            [type]="getFieldType(columnField)"
            [required]="$any(columnField.required)"
            [submitted]="submitted"
            [styleClass]="$any(styleClass)"
            [displayType]="displayType"
            [placeholder]="columnField.placeholder"
            [minDate]="columnField.minDate"
            [maxDate]="columnField.maxDate"
            [dateFormat]="columnField.dateFormat"
            [selectOptions]="columnField.selectOptions"
            [optionLabel]="columnField.optionLabel"
            [optionValue]="columnField.optionValue"
            [translateOptions]="columnField.translateOptions"
            (onStateChanged)="onFieldStateChanged($event)"
            [customValidateError]="columnField.customValidateError"
            [values]="values"
            (onFieldChanged)="columnField.onChanged ? columnField.onChanged($any($event)) : undefined"
            [autocomplete]="columnField.autocomplete"
            [passwordFeedback]="columnField.passwordFeedback"
            [passwordToggleMask]="columnField.passwordToggleMask"
            [readonly]="columnField.readonly"
            [disabled]="$any(columnField.disabled)"
            [validationType]="columnField.validationType"
            [maxLength]="columnField.maxLength"
            [minLength]="columnField.minLength"
            [calendarView]="columnField.calendarView"
            [hidePasswordHints]="columnField.hidePasswordHints"
          ></app-xn-form-control>
        </div>
      </ng-container>
    </div>
  </div>
  
</div>